import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';

interface BaseVectorColorOpacityOptionProps {
  fillAlpha: number;
  onChangeOpacity(updatedValue: number, undoable?: boolean): void;
  className?: string;
}

const VECTOR_COLOR_OPACITY_MIN = 0;
const VECTOR_COLOR_OPACITY_DISPLAY_MIN = 0;
const VECTOR_COLOR_OPACITY_MAX = 1;
const VECTOR_COLOR_OPACITY_DISPLAY_MAX = 100;

export function BaseVectorColorOpacityOption({className = '', ...props}: BaseVectorColorOpacityOptionProps): ReactElement<any> | null {
  return (
    <ContextualMenuSliderOptions
      id="vector-color-opacity-option"
      className={className}
      value={props.fillAlpha}
      label={window.i18next.t('pmwjs_opacity')}
      range={{
        min: VECTOR_COLOR_OPACITY_MIN,
        max: VECTOR_COLOR_OPACITY_MAX,
      }}
      transformDisplay={{
        min: VECTOR_COLOR_OPACITY_DISPLAY_MIN,
        max: VECTOR_COLOR_OPACITY_DISPLAY_MAX,
      }}
      onChange={(updatedValue: number): void => {
        props.onChangeOpacity(updatedValue, false);
      }}
      onChangeEnded={(updatedValue: number): void => {
        props.onChangeOpacity(updatedValue, true);
      }}
    />
  );
}
